var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "d-flex align-center justify-center fill-height",
      attrs: { fluid: "" },
    },
    [
      _c(
        "base-card",
        { attrs: { "max-width": "500" } },
        [
          _c("v-card-text", [
            _c(
              "div",
              {
                staticClass: "d-flex flex-column align-center text-center py-6",
              },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mb-4",
                    attrs: { size: "72", color: "warning" },
                  },
                  [_vm._v(" mdi-file-document-alert ")]
                ),
                _c("h2", { staticClass: "font-weight-bold mb-2" }, [
                  _vm._v("Código de formulario inválido"),
                ]),
                _c("v-divider", { staticClass: "mb-6" }),
                _c("p", { staticClass: "text--secondary mb-6" }, [
                  _vm._v(
                    " El formulario al que intentas acceder no existe, ha expirado o no está asociado a ninguna compañía. "
                  ),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }